import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcfbpLogoMono = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 248.06 90.2",
	style: { enableBackground: "new 0 0 248.06 90.2" },
	xmlSpace: "preserve",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M134.3,15.37h-30.51c-0.16,0-0.33,0.02-0.49,0.02c-4.69,0.26-8.41,4.12-8.41,8.87v43.36c0,3.2,2.6,5.8,5.8,5.8 h3.54c3.2,0,5.8-2.6,5.8-5.8V52.5l0.01-0.01v-12.1V28.53c0-0.59,0.48-1.06,1.06-1.06h23.16c2.19,0,3.96-1.76,3.98-3.95l0.03-4.14 C138.29,17.17,136.51,15.37,134.3,15.37z"
		}),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
			id: "SVGID_1_",
			fill: "currentColor",
			d: "M132.71,37.25c-2.03-0.12-4.06-0.16-6.09-0.1c-4.05,0.11-8.09,0.59-12.04,1.5 c-8.13,1.86-15.12,5.64-21.76,10.57c-3.08,2.29-6.13,4.65-9.42,6.65c-5.78,3.5-12.8,5.84-19.3,3.99 c-6.16-1.76-11-7.45-11.76-13.81c-0.75-6.36,2.63-13.02,8.21-16.17c5.58-3.15,13.03-2.59,18.08,1.34 c1.22,0.95,2.48,2.14,4.03,2.08c1.42-0.06,2.54-1.18,3.5-2.23c1.76-1.94,3.6-4.39,2.93-6.92c-0.43-1.64-1.84-2.83-3.24-3.79 c-7.56-5.17-17.4-6.88-26.27-4.57c-6.9,1.8-13.12,6.01-17.46,11.67c-4.49,5.85-5.98,13.87-4.96,21.13 c0.53,3.72,1.74,7.34,3.62,10.6c4.57,7.93,13,13.51,22.08,14.63c7.61,0.94,15.35-1.12,22.18-4.6 c7.97-4.06,14.69-10.03,21.64-15.62c5.48-4.41,11.11-8.6,17.6-11.44c4.48-1.96,9.18-3.42,13.99-4.34 C134.33,37.35,134.33,37.35,132.71,37.25z"
		}) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M32.21,21.11v46.43c0,3.2-2.6,5.8-5.8,5.8h-3.54c-3.2,0-5.8-2.6-5.8-5.8V21.11c0-3.2,2.6-5.8,5.8-5.8h3.54 C29.61,15.31,32.21,17.9,32.21,21.11z"
		}) }),
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("path", {
				fill: "currentColor",
				d: "M156.95,39.84c0,1.58-1.24,2.5-3.6,2.5h-4.58v-9.2h4.31c2.21,0,3.39,0.93,3.39,2.39 c0,0.95-0.47,1.64-1.18,2.03C156.28,37.87,156.95,38.64,156.95,39.84z M150.48,34.47v2.54h2.42c1.18,0,1.85-0.42,1.85-1.26 c0-0.85-0.67-1.28-1.85-1.28H150.48z M155.22,39.67c0-0.92-0.7-1.33-1.99-1.33h-2.76V41h2.76C154.53,41,155.22,40.59,155.22,39.67 z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "currentColor",
				d: "M159.36,38.33v-5.19h1.71v5.13c0,1.89,0.85,2.71,2.34,2.71c1.49,0,2.33-0.82,2.33-2.71v-5.13h1.68v5.19 c0,2.68-1.51,4.14-4.02,4.14C160.87,42.47,159.36,41.01,159.36,38.33z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "currentColor",
				d: "M169.7,41.36l0.59-1.33c0.74,0.59,1.91,1.01,3.04,1.01c1.43,0,2.04-0.51,2.04-1.2c0-1.99-5.47-0.68-5.47-4.1 c0-1.49,1.18-2.75,3.71-2.75c1.1,0,2.26,0.29,3.06,0.82l-0.54,1.33c-0.83-0.49-1.74-0.72-2.54-0.72c-1.42,0-2,0.55-2,1.25 c0,1.96,5.46,0.68,5.46,4.06c0,1.47-1.2,2.74-3.72,2.74C171.9,42.47,170.46,42.02,169.7,41.36z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "currentColor",
				d: "M179.41,33.13h1.71v9.2h-1.71V33.13z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "currentColor",
				d: "M192.44,33.13v9.2h-1.41l-5.07-6.23v6.23h-1.7v-9.2h1.41l5.07,6.23v-6.23H192.44z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "currentColor",
				d: "M202.48,40.9v1.43h-6.9v-9.2h6.72v1.43h-5.01v2.39h4.44v1.41h-4.44v2.54H202.48z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "currentColor",
				d: "M204.27,41.36l0.59-1.33c0.74,0.59,1.91,1.01,3.04,1.01c1.43,0,2.04-0.51,2.04-1.2c0-1.99-5.47-0.68-5.47-4.1 c0-1.49,1.18-2.75,3.71-2.75c1.1,0,2.26,0.29,3.06,0.82l-0.54,1.33c-0.83-0.49-1.74-0.72-2.54-0.72c-1.42,0-2,0.55-2,1.25 c0,1.96,5.46,0.68,5.46,4.06c0,1.47-1.2,2.74-3.72,2.74C206.47,42.47,205.04,42.02,204.27,41.36z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "currentColor",
				d: "M213.21,41.36l0.59-1.33c0.74,0.59,1.91,1.01,3.04,1.01c1.43,0,2.04-0.51,2.04-1.2c0-1.99-5.47-0.68-5.47-4.1 c0-1.49,1.18-2.75,3.71-2.75c1.1,0,2.26,0.29,3.06,0.82l-0.54,1.33c-0.83-0.49-1.74-0.72-2.54-0.72c-1.42,0-2,0.55-2,1.25 c0,1.96,5.46,0.68,5.46,4.06c0,1.47-1.2,2.74-3.72,2.74C215.4,42.47,213.97,42.02,213.21,41.36z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "currentColor",
				d: "M147.99,57.15l0.59-1.33c0.74,0.59,1.91,1.01,3.04,1.01c1.43,0,2.04-0.51,2.04-1.2c0-1.99-5.47-0.68-5.47-4.1 c0-1.49,1.18-2.75,3.71-2.75c1.1,0,2.26,0.29,3.06,0.82l-0.54,1.33c-0.83-0.49-1.73-0.72-2.54-0.72c-1.42,0-2,0.55-2,1.25 c0,1.96,5.46,0.68,5.46,4.06c0,1.47-1.2,2.74-3.72,2.74C150.19,58.26,148.76,57.81,147.99,57.15z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "currentColor",
				d: "M157.04,53.52c0-2.72,2.1-4.73,4.96-4.73c2.85,0,4.96,2,4.96,4.73c0,2.73-2.1,4.73-4.96,4.73 C159.15,58.26,157.04,56.24,157.04,53.52z M165.24,53.52c0-1.88-1.38-3.24-3.23-3.24c-1.85,0-3.23,1.35-3.23,3.24 c0,1.88,1.38,3.23,3.23,3.23C163.85,56.76,165.24,55.4,165.24,53.52z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "currentColor",
				d: "M169.44,48.92h1.71v7.76h4.81v1.45h-6.52V48.92z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "currentColor",
				d: "M177.76,54.11v-5.19h1.71v5.13c0,1.89,0.85,2.71,2.34,2.71s2.33-0.82,2.33-2.71v-5.13h1.68v5.19 c0,2.68-1.51,4.14-4.02,4.14C179.28,58.26,177.76,56.8,177.76,54.11z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "currentColor",
				d: "M190.58,50.37h-3.05v-1.45h7.81v1.45h-3.05v7.76h-1.71V50.37z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "currentColor",
				d: "M197.29,48.92H199v9.2h-1.71V48.92z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "currentColor",
				d: "M201.49,53.52c0-2.72,2.1-4.73,4.96-4.73c2.85,0,4.96,2,4.96,4.73c0,2.73-2.1,4.73-4.96,4.73 C203.59,58.26,201.49,56.24,201.49,53.52z M209.68,53.52c0-1.88-1.38-3.24-3.23-3.24c-1.85,0-3.24,1.35-3.24,3.24 c0,1.88,1.38,3.23,3.24,3.23C208.3,56.76,209.68,55.4,209.68,53.52z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "currentColor",
				d: "M222.06,48.92v9.2h-1.41l-5.08-6.23v6.23h-1.7v-9.2h1.41l5.08,6.23v-6.23H222.06z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "currentColor",
				d: "M224.42,57.15l0.59-1.33c0.74,0.59,1.91,1.01,3.04,1.01c1.43,0,2.04-0.51,2.04-1.2c0-1.99-5.47-0.68-5.47-4.1 c0-1.49,1.18-2.75,3.71-2.75c1.1,0,2.26,0.29,3.06,0.82l-0.54,1.33c-0.83-0.49-1.73-0.72-2.54-0.72c-1.42,0-2,0.55-2,1.25 c0,1.96,5.46,0.68,5.46,4.06c0,1.47-1.2,2.74-3.72,2.74C226.61,58.26,225.18,57.81,224.42,57.15z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "currentColor",
				d: "M156.47,67.98c0,2.02-1.5,3.27-3.92,3.27h-2.08v2.66h-1.71v-9.2h3.79C154.97,64.71,156.47,65.94,156.47,67.98 z M154.75,67.98c0-1.16-0.78-1.83-2.28-1.83h-2v3.66h2C153.98,69.81,154.75,69.14,154.75,67.98z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "currentColor",
				d: "M164.87,73.91l-1.88-2.7c-0.12,0.01-0.24,0.01-0.35,0.01h-2.08v2.68h-1.71v-9.2h3.79 c2.42,0,3.92,1.24,3.92,3.27c0,1.39-0.71,2.42-1.96,2.91l2.12,3.02H164.87z M162.55,66.15h-2v3.67h2c1.5,0,2.27-0.68,2.27-1.84 S164.05,66.15,162.55,66.15z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "currentColor",
				d: "M168.46,69.31c0-2.72,2.1-4.73,4.96-4.73c2.85,0,4.96,2,4.96,4.73c0,2.73-2.1,4.73-4.96,4.73 C170.57,74.04,168.46,72.03,168.46,69.31z M176.65,69.31c0-1.88-1.38-3.24-3.23-3.24c-1.85,0-3.23,1.35-3.23,3.24 c0,1.88,1.38,3.23,3.23,3.23C175.27,72.54,176.65,71.19,176.65,69.31z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "currentColor",
				d: "M188.98,64.71l-4.01,9.2h-1.68l-4.02-9.2h1.85l3.06,7.1l3.09-7.1H188.98z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "currentColor",
				d: "M190.62,64.71h1.71v9.2h-1.71V64.71z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "currentColor",
				d: "M195.47,64.71h4.02c2.98,0,5.02,1.84,5.02,4.6c0,2.76-2.04,4.6-5.02,4.6h-4.02V64.71z M199.42,72.47 c2.05,0,3.38-1.25,3.38-3.16c0-1.91-1.33-3.16-3.38-3.16h-2.24v6.31H199.42z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "currentColor",
				d: "M213.9,72.48v1.43H207v-9.2h6.72v1.43h-5.01v2.39h4.45v1.41h-4.45v2.54H213.9z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "currentColor",
				d: "M222.49,73.91l-1.88-2.7c-0.12,0.01-0.24,0.01-0.36,0.01h-2.08v2.68h-1.71v-9.2h3.79 c2.42,0,3.92,1.24,3.92,3.27c0,1.39-0.71,2.42-1.96,2.91l2.12,3.02H222.49z M220.18,66.15h-2v3.67h2c1.5,0,2.28-0.68,2.28-1.84 S221.68,66.15,220.18,66.15z"
			})
		] })
	] })
});
export default SvgIcfbpLogoMono;
